/**
 * @generated SignedSource<<43e2c4c6968281745d87e016124584bb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type requestDeleteRequestMutation$variables = {
  connections: ReadonlyArray<string>;
  id: string;
};
export type requestDeleteRequestMutation$data = {
  readonly deleteEventRequest: {
    readonly id: string;
  };
};
export type requestDeleteRequestMutation = {
  variables: requestDeleteRequestMutation$variables;
  response: requestDeleteRequestMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "connections"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "requestDeleteRequestMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "EventRequestDeletePayload",
        "kind": "LinkedField",
        "name": "deleteEventRequest",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "requestDeleteRequestMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "EventRequestDeletePayload",
        "kind": "LinkedField",
        "name": "deleteEventRequest",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "deleteEdge",
            "key": "",
            "kind": "ScalarHandle",
            "name": "id",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "352ba1b89507ff9fae494dea1affda8b",
    "id": null,
    "metadata": {},
    "name": "requestDeleteRequestMutation",
    "operationKind": "mutation",
    "text": "mutation requestDeleteRequestMutation(\n  $id: ID!\n) {\n  deleteEventRequest(id: $id) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "21dce1b52f76f375542a3dfac9ee1b6d";

export default node;
